import { Avatar } from '@/components'
import { ANIMAL } from '@/lib/enums'
import ModalChip from '@/views/app/Animals/Show/components/ModalChip'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import {
  Block, ChipButton, Footer, Identity, Top,
} from './styles'

function stopDrag(event) {
  event.preventDefault()
  event.stopPropagation()
}

function animalLine(animal) {
  const species = animal.category?.description
  const breed = animal.breed?.description
  return [species, breed].filter(Boolean).join(' · ')
}

function AnimalCard({ animal, onRemoved, onUpdated }) {
  const [chipOpened, setChipOpened] = useState(false)
  const chip = animal.chip?.uid
  const gender = animal.gender ? ANIMAL.gender.t(animal.gender) : ''
  const pending = animal.pendingChange
  const reverting = pending === 'remove'
  const tooltip = reverting ? 'Reverter' : 'Remover'

  function onDragStart(event) {
    event.dataTransfer.setData('text/plain', String(animal.id))
  }

  return (
    <Block
      className={pending ? undefined : 'bg-gray'}
      $tone={pending}
      draggable
      onDragStart={onDragStart}
    >
      <Top>
        <Avatar
          avatarSize="md"
          name={animal.name}
          photoURL={animal.photoURL}
          alt={`Foto de ${animal.name}`}
        />
        <Identity>
          <div className="text-small text-bold text-ellipsis">{animal.name}</div>
          <div className="text-tiny text-ellipsis">{animalLine(animal)}</div>
        </Identity>
        <button
          type="button"
          draggable
          className={`btn btn-sm btn-link tooltip tooltip-left${reverting ? '' : ' text-error'}`}
          data-tooltip={pending && !reverting ? 'Desfazer' : tooltip}
          onDragStart={stopDrag}
          onClick={() => onRemoved(animal)}
        >
          <i className={`fas ${reverting ? 'fa-undo' : 'fa-times'}`} />
        </button>
      </Top>
      <Footer>
        <div className="text-tiny">{gender}</div>
        <ChipButton
          type="button"
          draggable
          $empty={!chip}
          className="tooltip tooltip-left"
          data-tooltip={chip ? 'Alterar microchip' : 'Informar microchip'}
          onDragStart={stopDrag}
          onClick={() => setChipOpened(true)}
        >
          <i className="fas fa-microchip" />
          <span>{chip || 'Informar microchip'}</span>
          {chip ? <i className="fas fa-pen" /> : null}
        </ChipButton>
      </Footer>
      {
        chipOpened && (
          <ModalChip
            active={chipOpened}
            animal={animal}
            onChange={onUpdated}
            onClose={() => setChipOpened(false)}
          />
        )
      }
    </Block>
  )
}

AnimalCard.propTypes = {
  animal: PropTypes.objectOf(Object).isRequired,
  onRemoved: PropTypes.func.isRequired,
  onUpdated: PropTypes.func.isRequired,
}

export default AnimalCard
